import React from 'react';

const containerStyle = {
    minHeight: '100vh',
    display: 'grid',
    placeItems: 'center',
    padding: '24px',
    background: 'var(--sthenus-bg-main)',
};

export default function AuthLayout({ children }) {
    return <div style={containerStyle}>{children}</div>;
}
